import React from "react";
import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";

import { red, green, blue } from "@material-ui/core/colors";

import {
  Avatar as MuiAvatar,
  Box as MuiBox,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";

import {
  Add as AddIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  Delete as Delete,
  Create as Create,
  ChatBubbleOutline as ChatBubbleOutline,
} from "@material-ui/icons";

import { spacing } from "@material-ui/system";

import { AgentsService } from "../../services";

const Box = styled(MuiBox)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Avatar = styled(MuiAvatar)`
  background: ${(props) => props.theme.palette.primary.main};
`;

const Customer = styled.div`
  display: flex;
  align-items: center;
`;

function EnhancedTable() {
  const [page, setPage] = React.useState(0);
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    (async () => {
      const resList = await AgentsService.list(page);
      setData(resList.data);
    })();
  }, [page]);

  return (
    <div>
      <Paper>
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Data de Atualização</TableCell>
                <TableCell align="right">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.rows?.map((row, index) => {
                return (
                  <TableRow hover>
                    <TableCell component="th" id={index} scope="row">
                      <Customer>
                        <Avatar>{row.customerAvatar}</Avatar>
                        <Box ml={3}>
                          <strong>{row.name}</strong>
                        </Box>
                      </Customer>
                    </TableCell>
                    <TableCell>
                      {format(parseISO(row.updatedAt), "PPPP", {
                        locale: pt,
                      })}
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="Conversas">
                        <IconButton
                          component={NavLink}
                          to={`/platform/agents/${row.id}/threads`}
                          style={{ color: blue[700] }}
                        >
                          <ChatBubbleOutline />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Editar">
                        <IconButton
                          component={NavLink}
                          to={`/platform/agents/${row.id}/edit`}
                          style={{ color: blue[700] }}
                        >
                          <Create />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[6]}
          component="div"
          count={data.count || 0}
          rowsPerPage={6}
          page={page}
          onChangePage={(_, page) => setPage(page)}
        />
      </Paper>
    </div>
  );
}

export const AgentsIndexPage = () => {
  const history = useHistory();

  return (
    <Box p={8}>
      <Helmet title="Administradores" />

      <Grid justify="space-between" container>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Agentes
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Inicio
            </Link>
            <Typography>Portal do Administrador</Typography>
            <Typography>Agents</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item style={{ display: "flex", alignItems: "end" }}>
          <a target="_blank" href="https://docs.google.com/document/d/1Ehx2_v-QAXCF_utB99sd2xf67aYLZeBBCST0mCLkkkk/edit?tab=t.0">Prompt para Agente de Pré-Vendas na Guerini</a>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <EnhancedTable />
        </Grid>
      </Grid>
    </Box>
  );
};
